import React, {useEffect, useState, useRef} from 'react';
import { useLocation, useNavigate} from 'react-router-dom';
import axios from 'axios';
import '../css/RecruitmentDetail.css' ;
import Text from '../../../common/Text.js';
import imgProcess from '../img/img_recruitmentprocess.png';
import imgRect from '../img/imgRect.png';
import AttachFiles from '../../../common/AttachFiles.js';
import Cursor from 'quill/blots/cursor.js';



function RecruitmetIMGPopup() {

    const location = useLocation();
    var cardkey = location.state?.cardkey;
    
    const navigate = useNavigate();


    const ZoomIMGClick = () => {

        console.log('ZoomIMGClick22');
        console.log(cardkey);
        navigate('/RecruitmentDetail', {
            state: {
                cardkey: 67
            },
        });
    }


return(
     <div> 
           <img className='recruitsss' src={imgRect} onClick={() => ZoomIMGClick()} 
           style={{display: 'block',
            width : '1200px',
            margin : '0 auto',
            margintop : '30px',
            marginBottom : '30px'}}/>
    </div>


    );

}
export default RecruitmetIMGPopup;